// extracted by mini-css-extract-plugin
export default {"group":"segmented_group__EPUyb","option":"segmented_option__L48vq","optionIcon":"segmented_optionIcon__Ag6cv","optionSelected":"segmented_optionSelected__ofzFf"};